import React from 'react';
import { render, fireEvent, waitFor } from '@testing-library/react';

// Mock the API module
jest.mock('../../api', () => ({
  __esModule: true,
  default: {
    setHostAndProtocol: jest.fn(),
    getForm: jest.fn(),
    submitForm: jest.fn(),
  },
}));

// Mock form sub-components (resolved relative to this test file)
jest.mock('../../components/Button', () => ({ loading, submitted, submittedText }) => (
  <button type="submit" disabled={loading || submitted}>
    {submitted ? (submittedText || 'Submitted') : loading ? 'Loading...' : 'Submit'}
  </button>
));
jest.mock('../../components/Submitted', () => () => (
  <div data-testid="submitted">Thank you!</div>
));

import Form from '../Form';
import API from '../../api';

describe('Form', () => {
  const defaultProps = {
    item: {
      settings: {
        form: {
          form_id: 42,
        },
      },
    },
    host: 'orbitalsites.com',
    protocol: 'https',
  };

  beforeEach(() => {
    jest.useFakeTimers();
    fetch.resetMocks();
    API.getForm.mockReset();
    API.submitForm.mockReset();
    API.setHostAndProtocol.mockReset();
  });

  afterEach(() => {
    jest.useRealTimers();
  });

  it('renders "No form has been selected" initially before API loads', () => {
    API.getForm.mockReturnValue(new Promise(() => {})); // never resolves
    const { getByText } = render(<Form {...defaultProps} />);
    expect(getByText('No form has been selected')).toBeInTheDocument();
  });

  it('calls API.setHostAndProtocol on construction', () => {
    API.getForm.mockReturnValue(new Promise(() => {}));
    render(<Form {...defaultProps} />);
    expect(API.setHostAndProtocol).toHaveBeenCalledWith(
      'orbitalsites.com',
      'https'
    );
  });

  it('renders email form after API loads', async () => {
    API.getForm.mockReturnValue(
      Promise.resolve({
        id: 42,
        form_type: 'email',
      })
    );
    const { getByPlaceholderText } = render(<Form {...defaultProps} />);

    // Advance the 50ms delay timer
    jest.advanceTimersByTime(100);

    await waitFor(() => {
      expect(getByPlaceholderText('Enter your e-mail')).toBeInTheDocument();
    });
  });

  it('renders contact form after API loads', async () => {
    API.getForm.mockReturnValue(
      Promise.resolve({
        id: 42,
        form_type: 'contact',
      })
    );
    const { getByPlaceholderText } = render(<Form {...defaultProps} />);

    jest.advanceTimersByTime(100);

    await waitFor(() => {
      expect(getByPlaceholderText('Your name here')).toBeInTheDocument();
    });
  });

  it('has a honeypot field hidden with inputs class', async () => {
    API.getForm.mockReturnValue(
      Promise.resolve({
        id: 42,
        form_type: 'email',
      })
    );
    const { container } = render(<Form {...defaultProps} />);

    jest.advanceTimersByTime(100);

    await waitFor(() => {
      const honeypot = container.querySelector('input.inputs');
      expect(honeypot).toBeInTheDocument();
    });
  });

  it('does not render form when no form_id', () => {
    const props = {
      item: { settings: {} },
      host: 'orbitalsites.com',
      protocol: 'https',
    };
    const { getByText } = render(<Form {...props} />);
    expect(getByText('No form has been selected')).toBeInTheDocument();
  });
});
